import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { useUiStore } from '../stores/uiStore';
import { PageContainer, PageHeader } from '../components/common/page';
import { Card, Input, Label, Select } from '../components/common/ui';
export function SettingsPage() {
  useScreenInit();
  const {
    theme,
    setTheme,
    language,
    setLanguage,
    pushToast
  } = useUiStore();
  return <PageContainer data-id="element-805">
      <PageHeader title="系统设置" description="通用配置，不替代模型 / Skills / Agent 中心" data-id="element-806" />

      <div className="space-y-4" data-id="element-807">
        <Card className="p-5" data-id="element-808">
          <h3 className="mb-4 text-sm font-semibold text-slate-200" data-id="element-809">
            外观与语言
          </h3>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-810">
            <div data-id="element-811">
              <Label data-id="element-812">主题</Label>
              <Select value={theme} onChange={e => setTheme(e.target.value as any)} data-id="element-813">
                <option value="dark" data-id="element-814">暗色</option>
                <option value="light" data-id="element-815">亮色</option>
              </Select>
            </div>
            <div data-id="element-816">
              <Label data-id="element-817">语言</Label>
              <Select value={language} onChange={e => setLanguage(e.target.value as any)} data-id="element-818">
                <option value="zh" data-id="element-819">中文</option>
                <option value="en" data-id="element-820">English</option>
              </Select>
            </div>
          </div>
        </Card>

        <Card className="p-5" data-id="element-821">
          <h3 className="mb-4 text-sm font-semibold text-slate-200" data-id="element-822">
            运行参数
          </h3>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-823">
            <div data-id="element-824">
              <Label data-id="element-825">全局并发上限</Label>
              <Input type="number" defaultValue={16} data-id="element-826" />
            </div>
            <div data-id="element-827">
              <Label data-id="element-828">会话空闲回收时间 (分钟)</Label>
              <Input type="number" defaultValue={30} data-id="element-829" />
            </div>
            <div className="sm:col-span-2" data-id="element-830">
              <Label data-id="element-831">Skill 安装目录</Label>
              <Input defaultValue="/var/lib/agent-platform/skills" className="font-mono" data-id="element-832" />
            </div>
          </div>
        </Card>

        <Card className="p-5" data-id="element-833">
          <h3 className="mb-4 text-sm font-semibold text-slate-200" data-id="element-834">
            通知与安全
          </h3>
          <div className="space-y-3" data-id="element-835">
            <label className="flex items-center justify-between text-sm text-slate-300" data-id="element-836">
              任务完成通知
              <input type="checkbox" defaultChecked className="h-4 w-4 rounded border-slate-600 bg-slate-800 text-indigo-500" data-id="element-837" />
            </label>
            <label className="flex items-center justify-between text-sm text-slate-300" data-id="element-838">
              任务失败通知
              <input type="checkbox" defaultChecked className="h-4 w-4 rounded border-slate-600 bg-slate-800 text-indigo-500" data-id="element-839" />
            </label>
            <label className="flex items-center justify-between text-sm text-slate-300" data-id="element-840">
              第三方 Skill 强制 SHA256 校验
              <input type="checkbox" defaultChecked className="h-4 w-4 rounded border-slate-600 bg-slate-800 text-indigo-500" data-id="element-841" />
            </label>
          </div>
        </Card>

        <div className="flex justify-end" data-id="element-842">
          <button onClick={() => pushToast('success', '设置已保存')} className="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500" data-id="element-843">
            保存设置
          </button>
        </div>
      </div>
    </PageContainer>;
}